import React from "react";
import { ProtocoloDetalle } from "../../logic/domain/entities/ProtocoloDetalle";

type ProtocoloDetallesProps = {
  pedido: ProtocoloDetalle[];
  sx?: React.CSSProperties; // Definimos sx como un estilo opcional
};

function ProtocoloDetalles({ pedido, sx }: ProtocoloDetallesProps) {
  return (
    <div style={sx}> {/* Aplicamos sx como estilo en línea */}
      <table width="100%">
        <thead>
          <tr>
            <th>Código</th>
            <th>Descripción</th>
            <th>Mnemonico</th>
            <th>Estado</th>
          </tr>
        </thead>
        <tbody>
          {pedido &&
            pedido.map((prestacion: ProtocoloDetalle) => (
              <tr key={prestacion.getCodigo()}>
                <td>{prestacion.getCodigo()}</td>
                <td>{prestacion.getDescripcion()}</td>
                <td>{prestacion.getMnemonico()}</td>
                <td>
                  <input
                    type="checkbox"
                    name={"vis" + prestacion.getProcesar()}
                    checked={prestacion.getProcesar()}
                    disabled
                  />
                </td>
              </tr>
            ))}
        </tbody>
      </table>
    </div>
  );
}

export default ProtocoloDetalles;
